import { v4 as uuid } from "uuid";
import {Model} from "./base/Model";
import {Collection} from "./base/Collection";

    export class TenantUserFields extends Model  {
      key: string = "";
      information: string = "";
      send_password: number = 0;
      hour_price: number = 0;
      roles = [];
      userobj = null;
      
        constructor(data = null) {
            super(data);
        }      
    }